/** Floor loyalty points to match backend SQL FLOOR behavior. */
export function floorLoyaltyPoints(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.floor(n);
}

/** Normalize API reward payload (camelCase or PascalCase). */
export function normalizeReward(raw) {
    if (!raw || typeof raw !== "object") return null;
    const rewardId = raw.rewardId ?? raw.reward_ID ?? raw.Reward_ID;
    const rewardType = raw.rewardType ?? raw.RewardType ?? "";
    const discountType = raw.discountType ?? raw.DiscountType ?? "";
    const amount = Number(raw.amount ?? raw.Amount ?? 0);
    const requiredPoints = floorLoyaltyPoints(raw.requiredPoints ?? raw.RequiredPoints ?? 0);
    const freeItemId = raw.freeItemId ?? raw.FreeItemID ?? null;
    const canRedeem = raw.canRedeem ?? raw.CanRedeem ?? false;

    return {
        ...raw,
        rewardId,
        rewardName: raw.rewardName ?? raw.RewardName ?? "",
        rewardType: String(rewardType).trim(),
        discountType: String(discountType).trim(),
        amount,
        requiredPoints,
        freeItemId,
        itemName: raw.itemName ?? raw.ItemName ?? "",
        itemPrice: Number(raw.itemPrice ?? raw.ItemPrice ?? 0),
        canRedeem: canRedeem !== false,
        status: raw.status ?? raw.Status ?? true,
    };
}

/** Map cart line items for reward validation API. */
export function mapCartItemsForRewardValidation(cartItems = []) {
    return (Array.isArray(cartItems) ? cartItems : []).map((item) => {
        const qty = Number(item.quantity) || 1;
        const unitPrice = Number(item.price ?? item.itemPrice ?? item.basePrice ?? 0) || 0;
        const lineTotal = Number(item.total ?? item.subtotal ?? unitPrice * qty) || 0;
        // Cart lines use a unique `id` (cart_item_*) and store the menu item id on `productId`.
        // Prefer selectedVariantId (size/variant MenuItem_ID) so loyalty rules match correctly.
        const menuItemId = Number(
            item.selectedVariantId ??
            item.menuItemId ??
            item.productId ??
            item.menuItem_ID ??
            item.MenuItem_ID ??
            item.itemId ??
            item.originalItem?.MenuItem_ID ??
            item.originalItem?.menuItemId ??
            item.originalItem?.id ??
            (typeof item.id === "number" || (typeof item.id === "string" && /^\d+$/.test(item.id))
                ? item.id
                : 0) ??
            0
        );
        const categoryIdRaw =
            item.categoryId ??
            item.reportCatId ??
            item.reportCat_ID ??
            item.ReportCat_ID ??
            null;
        const categoryId =
            categoryIdRaw !== null && categoryIdRaw !== undefined && Number(categoryIdRaw) > 0
                ? Number(categoryIdRaw)
                : null;

        return {
            menuItemId,
            categoryId,
            unitPrice,
            quantity: qty,
            lineTotal,
        };
    }).filter((line) => line.menuItemId > 0);
}

export function getRewardDiscountLabel(reward, currencySymbol = "£") {
    const r = normalizeReward(reward);
    if (!r) return "";
    if (r.rewardType === "FREE_ITEM") {
        return r.itemName ? `Free ${r.itemName}` : "Free item";
    }
    if (r.discountType === "PERCENTAGE") {
        return `${r.amount}% off`;
    }
    return `${currencySymbol}${r.amount.toFixed(2)} off`;
}
